'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  config: {
    useMinimalHeader: false,
    hideHeaderButtons: false,
    version: 'v1',
    rtl: false
  },
  content: {
    minimalHeader: {
      labelMenuButton: 'Menu',
      labelClose: 'Close',
      logo: {
        text: 'PayPal',
        href: '/webapp/mpp/home'
      },
      headerButtons: [{
        text: 'Log In',
        href: '/signin'
      }, {
        text: 'Sign Up',
        href: '/webapps/mpp/account-selection',
        color: 'white'
      }]
    },
    mainMenuContent: [{
      type: 'subnav',
      text: 'Personal',
      href: '/webapps/mpp/home',
      subnavLinks: [{
        text: 'Getting Started',
        href: '/webapps/mpp/how-to-use-paypal'
      }, {
        text: 'Check Out Securely Online',
        href: '/webapps/mpp/pay-online'
      }, {
        text: 'Mobile Retailers',
        href: '/webapps/mpp/pay-with-app'
      }, {
        text: 'Mobile Wallet',
        href: '/webapps/mpp/pay-in-stores'
      }, {
        text: 'eBay Payments',
        href: '/webapps/mpp/pay-on-ebay'
      }, {
        text: 'Shopping and more',
        href: '/webapps/mpp/about-paypal-products'
      }],
      subnavLinksL2: [{
        text: 'Free Return Shipping',
        href: '/webapps/mpp/returns'
      }, {
        text: 'Fees',
        href: '/webapps/mpp/paypal-fees'
      }, {
        text: 'Security',
        href: '/webapps/mpp/paypal-safety-and-security'
      }]
    }, {
      type: 'subnav',
      text: 'Business',
      href: '/webapps/mpp/merchant',
      subnavLinks: [{
        text: 'All Business Solutions',
        subtext: 'Merchant services, invoicing and products',
        href: '/webapps/mpp/merchant'
      }, {
        text: 'Borrow for Your Business',
        subtext: 'Affordable business loans',
        href: '/webapps/mpp/merchant-working-capital'
      }, {
        text: 'Credit Card Processing',
        subtext: 'Accept debit and credit cards',
        href: '/webapps/mpp/accept-payments-online'
      }, {
        text: 'Mobile Card Reader',
        subtext: 'Use with your phone or tablet on the go',
        href: '/webapps/mpp/credit-card-reader'
      }, {
        text: 'Add PayPal to Your Checkout',
        subtext: 'Add the button and accept cards online',
        href: '/webapps/mpp/express-checkout'
      }, {
        text: 'Point of Sale Solutions',
        subtext: 'Get paid in your store',
        href: '/webapps/mpp/accept-payments-in-store'
      }]
    }, {
      type: 'linkOnly',
      text: 'Send',
      href: '/webapps/mpp/send-money-online'
    }, {
      type: 'linkOnly',
      text: 'Request',
      href: '/webapps/mpp/requesting-payments'
    }, {
      type: 'languageDesk',
      text: 'FR',
      href: '?locale.x=fr_CA'
    }, {
      type: 'languageMobile',
      text: 'Français',
      href: '?locale.x=fr_CA'
    }],
    sublistMobile: [{
      type: 'link',
      text: 'Partners & Developers',
      href: '/webapps/mpp/partner-program'
    }, {
      type: 'cta',
      text: 'Sign Up',
      href: '/webapps/mpp/account-selection'
    }]
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/header/jsx/components/MPPHeaderDefaultProps.js
// module id = 498
// module chunks = 4